import SymbolIcon from './SymbolIcon'
import './InputLeadingIcon.css'

export default function InputLeadingIcon({ icon }) {
  return <SymbolIcon icon={icon} className="input-leading-icon" />
}
